import { render, staticRenderFns } from "./AutomationCard.vue?vue&type=template&id=44c5b50a&scoped=true"
import script from "./AutomationCard.vue?vue&type=script&lang=js"
export * from "./AutomationCard.vue?vue&type=script&lang=js"
import style0 from "./AutomationCard.vue?vue&type=style&index=0&id=44c5b50a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c5b50a",
  null
  
)

export default component.exports